import { render, staticRenderFns } from "./TelegramSmmWidget.vue?vue&type=template&id=7d4e0f56&scoped=true&"
import script from "./TelegramSmmWidget.vue?vue&type=script&lang=js&"
export * from "./TelegramSmmWidget.vue?vue&type=script&lang=js&"
import style0 from "./TelegramSmmWidget.vue?vue&type=style&index=0&id=7d4e0f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4e0f56",
  null
  
)

export default component.exports